export default __webpack_public_path__ + "static/media/shoe-roto.0a6abb02.mp4";